<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat>
					<v-card-text class="pb-0 pt-2">
						<v-row class="pb-1">
							<v-col class="d-flex justify-start pa-0 pl-2">
								<v-btn color="primary" @click="addClick">
									<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
								</v-btn>
							</v-col>
							<v-col class="d-flex justify-center pb-0 pt-0">
								<v-card-title class="text-center pa-2 pb-2 pt-0">
									{{ $t('modules.preregistrations') }}
									<v-badge
										v-if="unreadCount > 0"
										color="primary"
										offset-x="-4"
										@click.native="filterUnread"
										:class="{ 'cursor-pointer': true }"
									>
										<template v-slot:badge>
											<v-tooltip bottom>
												<template v-slot:activator="{ on }">
													<span v-on="on">{{ unreadCount }}</span>
												</template>
												<span>{{ $t('tooltips.unreadPreregistrations') }}</span>
											</v-tooltip>
										</template>
									</v-badge>
								</v-card-title>
							</v-col>
							<v-col></v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0 pt-0">
								<TheTable
									:additional-filters="preregistrationsTable.additionalFilters"
									:default-sort="preregistrationsTable.defaultSort"
									:excel="true"
									:fields="preregistrationsTable.headers"
									:header-selection-key="'preregistrations-headers'"
									:height="preregistrationsTable.height"
									:total-records="preregistrationsTable.total"
									:filter-save-key="'preregistrations-filters'"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in preregistrationsTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true, 'unread-color': item.unread == 1 }"
										@contextmenu.prevent="editClick(props.item.id, true)"
									>
										<td>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="copyPreregistration(item.id)"
														v-on="on"
													>
														<v-icon small>fa-copy</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.copyPreregistration') }}</span>
											</v-tooltip>
										</td>
										<td
											v-if="preregistrationsTable.selectedHeaders.includes('id')"
											@click="editClick(item.id, false)"
										>
											{{ item.id }}
										</td>
										<td
											v-if="preregistrationsTable.selectedHeaders.includes('first_name')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.candidate_id ? item.candidate.first_name : item.first_name }}</b>
										</td>
										<td
											v-if="preregistrationsTable.selectedHeaders.includes('last_name')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.candidate_id ? item.candidate.last_name : item.last_name }}</b>
										</td>
										<td
											v-if="preregistrationsTable.selectedHeaders.includes('email')"
											@click="editClick(item.id, false)"
										>
											{{ item.candidate_id ? item.candidate.email : item.email }}
										</td>
										<td
											v-if="preregistrationsTable.selectedHeaders.includes('phone')"
											@click="editClick(item.id, false)"
										>
											{{ item.candidate_id ? item.candidate.phone : item.phone }}
										</td>
										<td
											v-if="preregistrationsTable.selectedHeaders.includes('partner_id')"
											@click="editClick(item.id, false)"
										>
											<b>{{
												item.candidate_id
													? item.partner_name
														? item.partner_name
														: '-'
													: item.partner
													? item.partner.name
													: '-'
											}}</b>
										</td>
										<td
											v-if="preregistrationsTable.selectedHeaders.includes('login_type_id')"
											@click="editClick(item.id, false)"
										>
											{{ item.login_type_id ? item.login_type.name : '' }}
										</td>
										<td
											v-if="preregistrationsTable.selectedHeaders.includes('course_id')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.course.code }}</b>
										</td>
										<td
											v-if="preregistrationsTable.selectedHeaders.includes('planned_course_id')"
											@click="editClick(item.id, false)"
										>
											<b>
												{{
													item.planned_course_id
														? (item.planned_course.office
																? item.planned_course.office.name
																: '') +
														  (item.start_date != null
																? ' - ' + item.start_date.split('-').reverse().join('.')
																: '') +
														  (item.planned_course.planned_course_status != null
																? ' - ' + item.planned_course.planned_course_status.name
																: '')
														: '-'
												}}
											</b>
										</td>
										<td
											v-if="preregistrationsTable.selectedHeaders.includes('start_date')"
											@click="editClick(item.id, false)"
										>
											{{
												item.start_date != null
													? item.start_date.split('-').reverse().join('.')
													: ''
											}}
										</td>
										<td
											v-if="preregistrationsTable.selectedHeaders.includes('office_id')"
											@click="editClick(item.id, false)"
										>
											{{ item.office ? item.office.name : '-' }}
										</td>
										<td
											class="truncate-note"
											v-if="preregistrationsTable.selectedHeaders.includes('note')"
											@click="editClick(item.id, false)"
										>
											{{ item.note }}
										</td>
										<td
											v-if="preregistrationsTable.selectedHeaders.includes('notified')"
											@click="editClick(item.id, false)"
										>
											<v-icon v-if="item.notified" small>fa-check</v-icon>
										</td>
										<td
											v-if="preregistrationsTable.selectedHeaders.includes('correctional')"
											@click="editClick(item.id, false)"
										>
											<v-icon v-if="item.correctional" small>fa-check</v-icon>
										</td>
										<td
											v-if="preregistrationsTable.selectedHeaders.includes('created_at')"
											@click="editClick(item.id, false)"
										>
											{{ item.created_at }}
										</td>
										<td
											v-if="preregistrationsTable.selectedHeaders.includes('updated_at')"
											@click="editClick(item.id, false)"
										>
											{{ item.updated_at }}
										</td>
										<td>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="editClick(item.id, true)"
														v-on="on"
													>
														<v-icon small>fa-external-link-alt</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.openInNewTab') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Preregistrations',
	components: { TheTable },
	data: function () {
		return {
			preregistrationsTable: {
				selectedHeaders: [],
				headers: [
					{ text: '', value: 'actions', type: '', sortable: false, width: '40px', allowFilter: false },
					{ text: this.$t('fields.id'), value: 'id', type: 'string', width: '70px', allowFilter: true },
					{ text: this.$t('fields.firstName'), value: 'first_name', type: 'string', allowFilter: true },
					{ text: this.$t('fields.lastName'), value: 'last_name', type: 'string', allowFilter: true },
					{ text: this.$t('fields.email'), value: 'email', type: 'string', allowFilter: true },
					{ text: this.$t('fields.phone'), value: 'phone', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.company'),
						value: 'partner_id',
						type: 'dropdown|partners',
						allowFilter: true,
					},
					{
						text: this.$t('fields.loginType'),
						value: 'login_type_id',
						type: 'dropdown|preregistration-login-types',
						allowFilter: true,
					},
					{
						text: this.$t('fields.course'),
						value: 'course_id',
						type: 'dropdown|courses-codes',
						width: '200px',
						allowFilter: true,
					},
					{
						text: this.$t('fields.plannedCourse'),
						value: 'planned_course_id',
						type: 'dropdown|planned-courses-with-status',
						allowFilter: true,
					},
					{
						text: this.$t('fields.startDate'),
						value: 'start_date',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.office'),
						value: 'office_id',
						type: 'dropdown|offices',
						allowFilter: true,
						width: '120px',
					},
					{ text: this.$t('fields.note'), value: 'note', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.notified'),
						value: 'notified',
						type: 'boolean',
						width: '100px',
						allowFilter: false,
					},
					{
						text: this.$t('fields.correctional'),
						value: 'correctional',
						type: 'boolean',
						width: '100px',
						allowFilter: false,
					},
					{
						text: this.$t('fields.dateCreated'),
						value: 'created_at',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.dateUpdated'),
						value: 'updated_at',
						type: '',
						allowFilter: true,
					},
					{ text: '', value: 'action', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [
					{
						text: this.$t('fields.startDate'),
						value: 'start_date',
						type: 'date_range',
					},
					{
						text: this.$t('fields.dateCreated'),
						value: 'created_at',
						type: 'date_range',
					},
					{
						text: this.$t('fields.dateUpdated'),
						value: 'updated_at',
						type: 'date_range',
					},
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'updated_at',
					descending: true,
				},
			},
			unreadCount: 0,
		};
	},
	methods: {
		addClick() {
			this.$router.push('/preregistrations/0');
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/preregistrations/' + id);
			} else {
				let routeData = this.$router.resolve('/preregistrations/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		copyPreregistration(id) {
			this.$router.push({
				name: 'preregistration',
				params: {
					id: 0,
				},
				query: {
					preregistration: id,
				},
			});
		},
		selectHeaders(headers) {
			this.preregistrationsTable.selectedHeaders = headers;
		},
		filterUnread() {
			let request = this.preregistrationsTable.lastRequest;
			request.search.unread = true;
			this.reloadData(request);
		},
		reloadData(request) {
			this.preregistrationsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'preregistrations',
				request,
				(data, success) => {
					if (success) {
						vm.preregistrationsTable.items = data.items;
						vm.preregistrationsTable.total = data.total;
						vm.unreadCount = data.unread_count;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.preregistrationsTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'preregistrations',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/preregistrations', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.preregistrationsTable.height = window.innerHeight - 243 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.preregistrations'), href: '/#/preregistrations', disabled: true },
		]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped>
.truncate-note {
	max-width: 250px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.unread-color {
	background: rgba(0, 158, 192, 0.2);
}
</style>
